import React, { useEffect, useState } from 'react'
import { Button, Card, Empty, Flex, Switch, Typography } from 'antd'

import {
  SYSTEM_TYPE,
  buildUpdateBody,
  formatCategoryLabel,
  formatProductLabel,
  groupByType,
} from './lib'
import { saveProduct } from './model'
import { ProductSubscription, SubscriptionCategory } from './types'

const { Text } = Typography

type Props = {
  item: ProductSubscription
  saving: boolean
}

export const ProductSubscriptionsCard: React.FC<Props> = ({ item, saving }) => {
  const serverState = item.subscriptions ?? []
  const serverSnapshot = JSON.stringify(serverState)

  const [draft, setDraft] = useState<SubscriptionCategory[]>(serverState)

  // Сброс черновика завязан на снимок данных, а не на ссылку item
  // перезапрос после сохранения соседнего продукта не должен стирать правки в этой карточке.
  useEffect(() => {
    setDraft(JSON.parse(serverSnapshot))
  }, [serverSnapshot])

  const isDirty = JSON.stringify(draft) !== serverSnapshot

  const toggle = (category: string, isActive: boolean) => {
    setDraft((prev) =>
      prev.map((subscription) =>
        subscription.Category === category
          ? { ...subscription, IsActive: isActive }
          : subscription,
      ),
    )
  }

  if (!serverState.length) {
    return (
      <Card title={formatProductLabel(item.product)} className="mb-3">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No subscriptions for this product"
        />
      </Card>
    )
  }

  return (
    <Card title={formatProductLabel(item.product)} className="mb-3">
      <Flex vertical gap="large">
        {groupByType(draft).map((group) => {
          const isSystem = group.type === SYSTEM_TYPE

          return (
            <Flex vertical gap="small" key={group.type}>
              <Text strong>{formatCategoryLabel(group.type)}</Text>
              {isSystem && (
                <Text type="secondary">
                  Service notifications stay on for every client.
                </Text>
              )}
              {group.items.map((subscription) => (
                <Flex
                  key={subscription.Category}
                  justify="space-between"
                  align="center"
                  gap="middle"
                >
                  <Text>{formatCategoryLabel(subscription.Category)}</Text>
                  <Switch
                    checked={subscription.IsActive}
                    disabled={isSystem || saving}
                    onChange={(checked) =>
                      toggle(subscription.Category, checked)
                    }
                  />
                </Flex>
              ))}
            </Flex>
          )
        })}
      </Flex>
      <Flex justify="flex-end" className="mt-4">
        <Button
          type="primary"
          loading={saving}
          disabled={!isDirty}
          onClick={() =>
            saveProduct({ id: item.id, body: buildUpdateBody(item, draft) })
          }
        >
          Save
        </Button>
      </Flex>
    </Card>
  )
}
